import Trigger from "./Trigger";
import MouseLabel from "./MouseLabel";
import { getLabel, useLabel, setLabel } from "./state/label";
MouseLabel.displayName = "MouseLabel";
MouseLabel.Trigger = Trigger;
MouseLabel.getLabel = getLabel;
MouseLabel.setLabel = setLabel;
MouseLabel.useLabel = useLabel;
export default MouseLabel;
//# sourceMappingURL=index.js.map